import { useTranslation } from 'react-i18next'

import Icon from '../Icon'
import {
  ChromeButton,
  HeaderWrapper,
  LoginButton,
  Logo,
  Nav,
  NavLeft,
  NavRight,
  PricingLink,
  // LanguageSelector,
  UserInfo,
} from './styles'

interface HeaderProps {
  isLoggedIn: boolean
  userInfo: any
  onLoginClick: () => void
  onPricingClick: () => void
}

const Header = ({ onLoginClick, onPricingClick, isLoggedIn, userInfo }: HeaderProps) => {
  const { t } = useTranslation()

  // const handleLanguageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
  //   const lang = event.target.value
  //   i18n.changeLanguage(lang)
  // }

  return (
    <HeaderWrapper>
      <Nav>
        <NavLeft>
          <Logo>
            <Icon type="logoCircle" />
          </Logo>
          {isLoggedIn && <UserInfo>{userInfo.user.email}</UserInfo>}
          {/* <LanguageSelector>
            <select onChange={handleLanguageChange} value={i18n.language}>
              <option value="en">English</option>
              <option value="zh">中文</option>
              <option value="fr">Français</option>
            </select>
          </LanguageSelector> */}
        </NavLeft>
        <NavRight>
          <PricingLink onClick={onPricingClick}>{t('pricing')}</PricingLink>
          {!isLoggedIn && <LoginButton onClick={onLoginClick}>{t('login')}</LoginButton>}
          <ChromeButton
            href="https://chromewebstore.google.com/category/extensions?hl=zh-cn&pli=1"
            className="small"
            target="_blank"
          >
            <Icon type="chrome" />
            {t('addToChrome')}
          </ChromeButton>
        </NavRight>
      </Nav>
    </HeaderWrapper>
  )
}

export default Header
